<template>
  <cleave :class="classes" :value="value" @input="$emit('input', $event)" :options="opt" :placeholder="placeholder"></cleave>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    classes: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'DD/MM/YYYY'
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      defaultOptions: {
        date: true,
        datePattern: ['Y']
      }
    };
  },
  computed: {
    opt() {
      return { ...this.defaultOptions, ...this.options };
    }
  },
};
</script>
